import React from "react";
import { SectionTitle } from "@/components/Bits";
import { WhatsAppButton } from "@/components/WhatsApp";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useLang } from "@/context/LanguageContext";
import { ShieldCheck, Heart, Target, Gem } from "lucide-react";

const ICONS = [ShieldCheck, Gem, Heart, Target];

export default function About() {
  const { t } = useLang();
  const values = t("pages.about.values").map((v, i) => ({ icon: ICONS[i], title: v.t, desc: v.d }));
  return (
    <div className="bg-ivory">
      <section className="relative py-24">
        <img src="https://images.unsplash.com/photo-1613977257363-707ba9348227?w=1920&q=85" alt="" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-navy/80" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
          <SectionTitle light eyebrow={t("pages.about.eyebrow")} title={t("pages.about.title")} subtitle={t("pages.about.subtitle")} />
        </div>
      </section>
      <section className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 py-20 grid lg:grid-cols-2 gap-14 items-center">
        <div>
          <SectionTitle eyebrow={t("pages.about.mEyebrow")} title={t("pages.about.mTitle")} />
          <p className="mt-6 text-slate-600 leading-relaxed">{t("pages.about.p1")}</p>
          <p className="mt-4 text-slate-600 leading-relaxed">{t("pages.about.p2")}</p>
          <div className="mt-8 flex flex-wrap gap-4">
            <Link to="/contact"><Button className="bg-navy text-white hover:bg-navy-600 h-11 px-7 rounded-lg">{t("pages.about.contact")}</Button></Link>
            <WhatsAppButton label={t("pages.about.advisor")} />
          </div>
        </div>
        <img src="https://images.unsplash.com/photo-1724582586529-62622e50c0b3?w=900&q=85" alt="" className="rounded-2xl w-full aspect-[4/3] object-cover" />
      </section>
      <section className="bg-white border-y border-black/5 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
          <SectionTitle center eyebrow={t("pages.about.vEyebrow")} title={t("pages.about.vTitle")} className="mb-12" />
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {values.map((v) => (
              <div key={v.title} className="text-center rounded-xl border border-black/5 p-7 card-hover">
                <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-gold/15 text-gold"><v.icon className="h-7 w-7" /></span>
                <h3 className="mt-4 font-serif text-xl font-semibold text-navy">{v.title}</h3>
                <p className="mt-2 text-sm text-slate-600">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
